import React from 'react';
import propTypes from 'prop-types';
import * as iconProperties from '../../constants/icons';

const newLocal = <path d="M0,0H24V24H0Z" fill="none" />;

const SVG = (props) => {
  const {
    children,
    width,
    height,
    viewbox,
    fill,
    dataTestId,
    ariaLabel,
    className,
    enableBackground,
  } = props;
  return (
    <svg
      xmlns={iconProperties.XMLNS}
      width={width || iconProperties.WIDTH}
      height={height || iconProperties.HEIGHT}
      viewBox={viewbox || iconProperties.VIEWBOX}
      fill={fill || iconProperties.FILL}
      className={className}
      data-testid={dataTestId}
      aria-label={ariaLabel}
      enableBackground={enableBackground}
    >
      {children}
      {newLocal}
    </svg>
  );
};

SVG.propTypes = {
  className: propTypes.string,
  children: propTypes.node.isRequired,
  width: propTypes.string,
  height: propTypes.string,
  viewbox: propTypes.string,
  fill: propTypes.string,
};

SVG.defaultProps = {
  className: '',
  width: '24px',
  height: '24px',
  viewbox: '0 0 24 24',
  fill: 'none',
};

export default SVG;
